// extracted by mini-css-extract-plugin
export default {"error":"Select_error__qjsIu","input":"Select_input__e1hIt","label":"Select_label__AKavy"};